import React, { createContext, useContext, useState } from 'react';

const HighlightedAxisContext = createContext();

export function HighlightedAxisProvider({ children }) {
  const [highlightedAxis, setHighlightedAxis] = useState([
    { axisId: 'x-axis', dataIndex: 0 },
  ]);
  return (
    <HighlightedAxisContext.Provider
      value={{ highlightedAxis, setHighlightedAxis }}
    >
      {children}
    </HighlightedAxisContext.Provider>
  );
}

export function useHighlightedAxis() {
  return useContext(HighlightedAxisContext);
}
